import { createI18n } from 'vue-i18n'
import enums from '../i18n/enums.json'
import general from '../i18n/general.json'
import toasts from '../i18n/toasts.json'

const numberFormats = {
  en: {
    currency: {
      style: 'currency',
      currency: 'EUR',
      notation: 'standard',
    },
    euros: {
      style: 'currency',
      currency: 'EUR',
      notation: 'standard',
      maximumFractionDigits: 0,
    },
    decimal: {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    percent: {
      style: 'percent',
      useGrouping: false,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
  },
  de: {
    currency: {
      style: 'currency',
      currency: 'EUR',
      notation: 'standard',
    },
    euros: {
      style: 'currency',
      currency: 'EUR',
      notation: 'standard',
      maximumFractionDigits: 0,
    },
    decimal: {
      style: 'decimal',
      minimumSignificantDigits: 2,
      maximumSignificantDigits: 2,
    },
    percent: {
      style: 'percent',
      useGrouping: false,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
  },
} as const

export const i18n = createI18n({
  locale: 'de',
  fallbackLocale: 'de',
  globalInjection: true,
  messages: {
    de: {
      ...general.de,
      ...enums.de,
      ...toasts.de,
    },
    en: {
      ...general.en,
      ...enums.en,
      ...toasts.en,
    },
  },
  legacy: false,
  numberFormats,
})
